/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateCommentRequest,
  FeedbackCommentDto,
  FeedbackStatsDto,
  FeedbackTicketDto,
  GetAdminFeedbackParams,
  UpdateFeedbackStatusRequest,
} from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary List
 */
export const getAdminFeedback = (
  params?: GetAdminFeedbackParams,
  signal?: AbortSignal,
) => {
  return customInstance<FeedbackTicketDto[]>({
    url: `/admin/feedback`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAdminFeedbackInfiniteQueryKey = (
  params?: GetAdminFeedbackParams,
) => {
  return ["infinite", `/admin/feedback`, ...(params ? [params] : [])] as const;
};

export const getGetAdminFeedbackQueryKey = (
  params?: GetAdminFeedbackParams,
) => {
  return [`/admin/feedback`, ...(params ? [params] : [])] as const;
};

export const getGetAdminFeedbackInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedback>>>,
  TError = void,
>(
  params?: GetAdminFeedbackParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedback>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminFeedbackInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminFeedback>>
  > = ({ signal }) => getAdminFeedback(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminFeedback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminFeedbackInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminFeedback>>
>;
export type GetAdminFeedbackInfiniteQueryError = void;

export function useGetAdminFeedbackInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedback>>>,
  TError = void,
>(
  params: undefined | GetAdminFeedbackParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedback>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedback>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedback>>>,
  TError = void,
>(
  params?: GetAdminFeedbackParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedback>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedback>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedback>>>,
  TError = void,
>(
  params?: GetAdminFeedbackParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedback>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List
 */

export function useGetAdminFeedbackInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedback>>>,
  TError = void,
>(
  params?: GetAdminFeedbackParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedback>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminFeedbackInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminFeedbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminFeedback>>,
  TError = void,
>(
  params?: GetAdminFeedbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedback>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminFeedbackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminFeedback>>
  > = ({ signal }) => getAdminFeedback(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminFeedback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminFeedbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminFeedback>>
>;
export type GetAdminFeedbackQueryError = void;

export function useGetAdminFeedback<
  TData = Awaited<ReturnType<typeof getAdminFeedback>>,
  TError = void,
>(
  params: undefined | GetAdminFeedbackParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedback>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedback>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedback<
  TData = Awaited<ReturnType<typeof getAdminFeedback>>,
  TError = void,
>(
  params?: GetAdminFeedbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedback>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedback>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedback<
  TData = Awaited<ReturnType<typeof getAdminFeedback>>,
  TError = void,
>(
  params?: GetAdminFeedbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedback>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List
 */

export function useGetAdminFeedback<
  TData = Awaited<ReturnType<typeof getAdminFeedback>>,
  TError = void,
>(
  params?: GetAdminFeedbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedback>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminFeedbackQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download
 */
export const getAdminFeedbackAttachmentsAttachmentId = (
  attachmentId: number,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/admin/feedback/attachments/${attachmentId}`,
    method: "GET",
    signal,
  });
};

export const getGetAdminFeedbackAttachmentsAttachmentIdInfiniteQueryKey = (
  attachmentId?: number,
) => {
  return ["infinite", `/admin/feedback/attachments/${attachmentId}`] as const;
};

export const getGetAdminFeedbackAttachmentsAttachmentIdQueryKey = (
  attachmentId?: number,
) => {
  return [`/admin/feedback/attachments/${attachmentId}`] as const;
};

export const getGetAdminFeedbackAttachmentsAttachmentIdInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
  >,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdminFeedbackAttachmentsAttachmentIdInfiniteQueryKey(attachmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
  > = ({ signal }) =>
    getAdminFeedbackAttachmentsAttachmentId(attachmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!attachmentId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminFeedbackAttachmentsAttachmentIdInfiniteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
  >;
export type GetAdminFeedbackAttachmentsAttachmentIdInfiniteQueryError = void;

export function useGetAdminFeedbackAttachmentsAttachmentIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
  >,
  TError = void,
>(
  attachmentId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackAttachmentsAttachmentIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
  >,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackAttachmentsAttachmentIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
  >,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download
 */

export function useGetAdminFeedbackAttachmentsAttachmentIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
  >,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetAdminFeedbackAttachmentsAttachmentIdInfiniteQueryOptions(
      attachmentId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminFeedbackAttachmentsAttachmentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdminFeedbackAttachmentsAttachmentIdQueryKey(attachmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
  > = ({ signal }) =>
    getAdminFeedbackAttachmentsAttachmentId(attachmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!attachmentId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminFeedbackAttachmentsAttachmentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
>;
export type GetAdminFeedbackAttachmentsAttachmentIdQueryError = void;

export function useGetAdminFeedbackAttachmentsAttachmentId<
  TData = Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
  TError = void,
>(
  attachmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackAttachmentsAttachmentId<
  TData = Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackAttachmentsAttachmentId<
  TData = Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download
 */

export function useGetAdminFeedbackAttachmentsAttachmentId<
  TData = Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
  TError = void,
>(
  attachmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackAttachmentsAttachmentId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminFeedbackAttachmentsAttachmentIdQueryOptions(
    attachmentId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Stats
 */
export const getAdminFeedbackStats = (signal?: AbortSignal) => {
  return customInstance<FeedbackStatsDto>({
    url: `/admin/feedback/stats`,
    method: "GET",
    signal,
  });
};

export const getGetAdminFeedbackStatsInfiniteQueryKey = () => {
  return ["infinite", `/admin/feedback/stats`] as const;
};

export const getGetAdminFeedbackStatsQueryKey = () => {
  return [`/admin/feedback/stats`] as const;
};

export const getGetAdminFeedbackStatsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackStats>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAdminFeedbackStats>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminFeedbackStatsInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminFeedbackStats>>
  > = ({ signal }) => getAdminFeedbackStats(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminFeedbackStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminFeedbackStatsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminFeedbackStats>>
>;
export type GetAdminFeedbackStatsInfiniteQueryError = void;

export function useGetAdminFeedbackStatsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackStats>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackStats>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackStatsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackStats>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackStats>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackStatsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackStats>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackStats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Stats
 */

export function useGetAdminFeedbackStatsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackStats>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackStats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminFeedbackStatsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminFeedbackStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminFeedbackStats>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAdminFeedbackStats>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminFeedbackStatsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminFeedbackStats>>
  > = ({ signal }) => getAdminFeedbackStats(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminFeedbackStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminFeedbackStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminFeedbackStats>>
>;
export type GetAdminFeedbackStatsQueryError = void;

export function useGetAdminFeedbackStats<
  TData = Awaited<ReturnType<typeof getAdminFeedbackStats>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackStats>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackStats<
  TData = Awaited<ReturnType<typeof getAdminFeedbackStats>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackStats>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackStats<
  TData = Awaited<ReturnType<typeof getAdminFeedbackStats>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackStats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Stats
 */

export function useGetAdminFeedbackStats<
  TData = Awaited<ReturnType<typeof getAdminFeedbackStats>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackStats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminFeedbackStatsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get
 */
export const getAdminFeedbackId = (id: number, signal?: AbortSignal) => {
  return customInstance<FeedbackTicketDto>({
    url: `/admin/feedback/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetAdminFeedbackIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/admin/feedback/${id}`] as const;
};

export const getGetAdminFeedbackIdQueryKey = (id?: number) => {
  return [`/admin/feedback/${id}`] as const;
};

export const getGetAdminFeedbackIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminFeedbackIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminFeedbackId>>
  > = ({ signal }) => getAdminFeedbackId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminFeedbackId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminFeedbackIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminFeedbackId>>
>;
export type GetAdminFeedbackIdInfiniteQueryError = void;

export function useGetAdminFeedbackIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackId>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackId>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get
 */

export function useGetAdminFeedbackIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminFeedbackIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminFeedbackIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminFeedbackId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminFeedbackIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminFeedbackId>>
  > = ({ signal }) => getAdminFeedbackId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminFeedbackId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminFeedbackIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminFeedbackId>>
>;
export type GetAdminFeedbackIdQueryError = void;

export function useGetAdminFeedbackId<
  TData = Awaited<ReturnType<typeof getAdminFeedbackId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackId>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackId<
  TData = Awaited<ReturnType<typeof getAdminFeedbackId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackId>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackId<
  TData = Awaited<ReturnType<typeof getAdminFeedbackId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get
 */

export function useGetAdminFeedbackId<
  TData = Awaited<ReturnType<typeof getAdminFeedbackId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminFeedbackIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteAdminFeedbackId = (id: number) => {
  return customInstance<void>({
    url: `/admin/feedback/${id}`,
    method: "DELETE",
  });
};

export const getDeleteAdminFeedbackIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminFeedbackId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminFeedbackId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAdminFeedbackId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminFeedbackId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminFeedbackId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminFeedbackIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminFeedbackId>>
>;

export type DeleteAdminFeedbackIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteAdminFeedbackId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAdminFeedbackId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminFeedbackId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteAdminFeedbackIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Comments
 */
export const getAdminFeedbackIdComments = (
  id: number,
  signal?: AbortSignal,
) => {
  return customInstance<FeedbackCommentDto[]>({
    url: `/admin/feedback/${id}/comments`,
    method: "GET",
    signal,
  });
};

export const getGetAdminFeedbackIdCommentsInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/admin/feedback/${id}/comments`] as const;
};

export const getGetAdminFeedbackIdCommentsQueryKey = (id?: number) => {
  return [`/admin/feedback/${id}/comments`] as const;
};

export const getGetAdminFeedbackIdCommentsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackIdComments>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminFeedbackIdCommentsInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminFeedbackIdComments>>
  > = ({ signal }) => getAdminFeedbackIdComments(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminFeedbackIdCommentsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminFeedbackIdComments>>
>;
export type GetAdminFeedbackIdCommentsInfiniteQueryError = void;

export function useGetAdminFeedbackIdCommentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackIdComments>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackIdComments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackIdCommentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackIdComments>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackIdComments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackIdCommentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackIdComments>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Comments
 */

export function useGetAdminFeedbackIdCommentsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminFeedbackIdComments>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminFeedbackIdCommentsInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminFeedbackIdCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminFeedbackIdCommentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminFeedbackIdComments>>
  > = ({ signal }) => getAdminFeedbackIdComments(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminFeedbackIdCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminFeedbackIdComments>>
>;
export type GetAdminFeedbackIdCommentsQueryError = void;

export function useGetAdminFeedbackIdComments<
  TData = Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackIdComments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackIdComments<
  TData = Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeedbackIdComments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminFeedbackIdComments<
  TData = Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Comments
 */

export function useGetAdminFeedbackIdComments<
  TData = Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminFeedbackIdComments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminFeedbackIdCommentsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add Comment
 */
export const postAdminFeedbackIdComments = (
  id: number,
  createCommentRequest: CreateCommentRequest,
  signal?: AbortSignal,
) => {
  return customInstance<FeedbackCommentDto>({
    url: `/admin/feedback/${id}/comments`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createCommentRequest,
    signal,
  });
};

export const getPostAdminFeedbackIdCommentsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminFeedbackIdComments>>,
    TError,
    { id: number; data: CreateCommentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminFeedbackIdComments>>,
  TError,
  { id: number; data: CreateCommentRequest },
  TContext
> => {
  const mutationKey = ["postAdminFeedbackIdComments"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminFeedbackIdComments>>,
    { id: number; data: CreateCommentRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postAdminFeedbackIdComments(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminFeedbackIdCommentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminFeedbackIdComments>>
>;
export type PostAdminFeedbackIdCommentsMutationBody = CreateCommentRequest;
export type PostAdminFeedbackIdCommentsMutationError = void;

/**
 * @summary Add Comment
 */
export const usePostAdminFeedbackIdComments = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminFeedbackIdComments>>,
      TError,
      { id: number; data: CreateCommentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminFeedbackIdComments>>,
  TError,
  { id: number; data: CreateCommentRequest },
  TContext
> => {
  const mutationOptions =
    getPostAdminFeedbackIdCommentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Status
 */
export const putAdminFeedbackIdStatus = (
  id: number,
  updateFeedbackStatusRequest: UpdateFeedbackStatusRequest,
) => {
  return customInstance<FeedbackTicketDto>({
    url: `/admin/feedback/${id}/status`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateFeedbackStatusRequest,
  });
};

export const getPutAdminFeedbackIdStatusMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAdminFeedbackIdStatus>>,
    TError,
    { id: number; data: UpdateFeedbackStatusRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAdminFeedbackIdStatus>>,
  TError,
  { id: number; data: UpdateFeedbackStatusRequest },
  TContext
> => {
  const mutationKey = ["putAdminFeedbackIdStatus"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAdminFeedbackIdStatus>>,
    { id: number; data: UpdateFeedbackStatusRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return putAdminFeedbackIdStatus(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAdminFeedbackIdStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAdminFeedbackIdStatus>>
>;
export type PutAdminFeedbackIdStatusMutationBody = UpdateFeedbackStatusRequest;
export type PutAdminFeedbackIdStatusMutationError = void;

/**
 * @summary Update Status
 */
export const usePutAdminFeedbackIdStatus = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAdminFeedbackIdStatus>>,
      TError,
      { id: number; data: UpdateFeedbackStatusRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAdminFeedbackIdStatus>>,
  TError,
  { id: number; data: UpdateFeedbackStatusRequest },
  TContext
> => {
  const mutationOptions = getPutAdminFeedbackIdStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
